/**
 * The Journey Network — the four Cardinal Virtue Journeys.
 * Rendered at the end of every Virtue Journey as "Continue Your Journey"
 * cards. Cards become links automatically once a Journey is published
 * (slug match against published virtues entries) — no manual editing.
 *
 * Guardian symbols: Wisdom uses the Founder's official illuminated
 * artwork; the others carry refined interim line symbols until the
 * Founder uploads their official Guardian artworks.
 */
import { Shield, Scale, Leaf } from "lucide-react";

export const VIRTUE_JOURNEYS = [
  { number: "001", slug: "wisdom",     guardianImg: "/journey-title-w.jpg", Icon: null },
  { number: "002", slug: "courage",    guardianImg: null, Icon: Shield },
  { number: "003", slug: "justice",    guardianImg: null, Icon: Scale },
  { number: "004", slug: "temperance", guardianImg: null, Icon: Leaf },
];
